import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';

/**
 * International phone field with country flags + E.164 formatting (default country Nigeria).
 */
export default function ContactPhoneInput({ id, value, onChange, error, ariaDescribedBy }) {
  return (
    <div className={`ca-phone-input ${error ? 'ca-phone-input--error' : ''}`}>
      <PhoneInput
        id={id}
        name="phone"
        international
        defaultCountry="NG"
        countryCallingCodeEditable={false}
        smartCaret
        limitMaxLength
        value={value}
        onChange={onChange}
        numberInputProps={{
          autoComplete: 'tel',
          'aria-invalid': error ? 'true' : undefined,
          'aria-describedby': error && ariaDescribedBy ? ariaDescribedBy : undefined,
        }}
      />
    </div>
  );
}
